<!-- Content Header (Page header) -->
<section class="content-header">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-sm-6">
                <h1>Productos</h1>
            </div>
            <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                    <li class="breadcrumb-item"><a [routerLink]="['/']">Dashboard</a></li>
                    <li class="breadcrumb-item active">Productos</li>
                </ol>
            </div>
        </div>
    </div><!-- /.container-fluid -->
</section>

<!-- Main content -->
<section class="content">
    <div class="container-fluid">
        <div class="row  justify-content-center">
            <div class="col-md-9">
                <app-new-producto (updateData)="getData()"></app-new-producto>
                <app-lista-productos (updateData)="getData()" [rows]="rows" [tempRows]="tempRows"></app-lista-productos>
            </div>
        </div>
    </div>
</section>
<!-- /.content -->